export enum SEARCH {
    ALL_TAB = 'SEARCH_PLUS_ALL_TAB',
    DRIVE = 'SEARCH_PLUS_DRIVE_TAB',
    GOOGLE_DRIVE_PRIVACY_PRIVATE_DESCRIPTION = 'FRONT.GOOGLE_DRIVE_PRIVACY.PRIVATE_DESCRIPTION',
    GOOGLE_DRIVE_PRIVACY_PUBLIC_DESCRIPTION = 'FRONT.GOOGLE_DRIVE_PRIVACY.PUBLIC_DESCRIPTION',
    GOOGLE_DRIVE_PRIVACY_PUBLIC_WITH_LINK_DESCRIPTION = 'FRONT.GOOGLE_DRIVE_PRIVACY.PUBLIC_WITH_LINK_DESCRIPTION',
    RESULT_IS_FEATURED = 'FRONT.SEARCH.RESULT_IS_FEATURED',
    RESULT_IS_PROMOTED = 'FRONT.SEARCH.RESULT_IS_PROMOTED',
    SEARCH_RESULTS_FOR = 'FRONT.SEARCH_RESULTS_FOR',
    SHAREPOINT = 'SEARCH_PLUS_SHAREPOINT_TAB',
    ZENDESK = 'SEARCH_PLUS_ZENDESK_TAB',
    ZENDESK_TICKET_STATUSES_CLOSED = 'FRONT.ZENDESK.TICKET_STATUS.CLOSED',
    ZENDESK_TICKET_STATUSES_HOLD = 'FRONT.ZENDESK.TICKET_STATUS.HOLD',
    ZENDESK_TICKET_STATUSES_NEW = 'FRONT.ZENDESK.TICKET_STATUS.NEW',
    ZENDESK_TICKET_STATUSES_OPEN = 'FRONT.ZENDESK.TICKET_STATUS.OPEN',
    ZENDESK_TICKET_STATUSES_PENDING = 'FRONT.ZENDESK.TICKET_STATUS.PENDING',
    ZENDESK_TICKET_STATUSES_SOLVED = 'FRONT.ZENDESK.TICKET_STATUS.SOLVED',
    ZENDESK_TYPE = 'FRONT.ZENDESK.TYPE',
    ZENDESK_TYPE_ARTICLE = 'FRONT.ZENDESK.TYPE.ARTICLE',
    ZENDESK_TYPE_TICKET = 'FRONT.ZENDESK.TYPE.TICKET',
}
